//使用当前的变量的文件包括： mobile.js\common.js，m-index.js,m-common.js,index.ejs
//视频路径
//http://website.chinarenaissance.com/
var api = {
    pcApi: 'https://website.huaxing.com/',
    webApi: 'https://website.huaxing.com/',
    // 视频链接
    pcVideo: 'https://www-website.huaxing.com/',
    webVideo: 'https://www-website.huaxing.com/',
    // minio url
    minioUrl: 'https://www-website.huaxing.com',
}
if (process.env.API_ENV === 'test') {
    api = {
        pcApi: 'https://website-test.huaxing.com/',
        webApi: 'https://website-test.huaxing.com/',
        // 视频链接
        pcVideo: 'https://www.huaxing.com/',
        webVideo: 'https://www.huaxing.com/',
        // minio url
        minioUrl: 'https://oss-test.huaxing.com/www-public',
    }
}

// Browser values are injected by Webpack; Node reads the same environment at runtime.
if (process.env.PUBLIC_API_BASE_URL) {
    api.pcApi = api.webApi = process.env.PUBLIC_API_BASE_URL.replace(/\/+$/, '') + '/';
}
if (process.env.PUBLIC_FILE_BASE_URL) {
    api.minioUrl = process.env.PUBLIC_FILE_BASE_URL.replace(/\/+$/, '');
}
if (process.env.PUBLIC_VIDEO_BASE_URL) {
    api.pcVideo = api.webVideo = process.env.PUBLIC_VIDEO_BASE_URL.replace(/\/+$/, '') + '/';
}

exports.api = api;



// WEBPACK FOOTER //
// ./commonApi.js